var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8204 37.4099C34.3954 38.4599 32.5204 38.9998 30.2854 38.9998H17.7154C17.3554 38.9998 16.9954 38.9848 16.6504 38.9398L27.0004 28.5898L35.8204 37.4099Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9998 17.7154V30.2854C38.9998 32.5204 38.4599 34.3954 37.4099 35.8204L28.5898 27.0004L38.9398 16.6504C38.9848 16.9954 38.9998 17.3554 38.9998 17.7154Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.59 27L37.41 35.82C36.975 36.45 36.45 36.975 35.82 37.41L27 28.59L16.65 38.94C15.69 38.88 14.82 38.685 14.025 38.385C10.815 37.215 9 34.365 9 30.285V17.715C9 12.255 12.255 9 17.715 9H30.285C34.365 9 37.215 10.815 38.385 14.025C38.685 14.82 38.88 15.69 38.94 16.65L28.59 27Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5904 27.0004L37.4104 35.8204C36.9754 36.4504 36.4504 36.9754 35.8204 37.4104L27.0004 28.5904L16.6504 38.9404C15.6904 38.8804 14.8204 38.6854 14.0254 38.3854L14.6104 37.8004L38.3854 14.0254C38.6854 14.8204 38.8804 15.6904 38.9404 16.6504L28.5904 27.0004Z",
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3602 17.8949C23.7902 15.4199 21.6002 14.3099 19.6802 14.2949C17.7602 14.2949 15.5702 15.4049 15.0002 17.8799C14.3702 20.6249 16.0502 22.9199 17.5652 24.3599C18.1652 24.9299 18.9152 25.1999 19.6802 25.1999C20.4452 25.1999 21.1952 24.9149 21.7952 24.3599C23.3102 22.9199 24.9902 20.6249 24.3602 17.8949ZM19.7252 20.2349C18.9002 20.2349 18.2252 19.5599 18.2252 18.7349C18.2252 17.9099 18.8852 17.2349 19.7252 17.2349H19.7402C20.5652 17.2349 21.2402 17.9099 21.2402 18.7349C21.2402 19.5599 20.5502 20.2349 19.7252 20.2349Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.a8282dda79837bc0299a80aedd9387e2.svg";
export { ForwardRef as ReactComponent };